#### Replay events prior to subscription

We’ve updated the [`replayWebhookSubscription` mutation] to replay events that were emitted prior to a subscription or a hirer relationship being created.
This allows you to backfill events for a hirer without having to contact SEEK.

To accommodate this change, the fields in [`replayWebhookSubscription` filter input] are now mandatory.
In addition, a `hirerId` must be provided for partner-scoped subscriptions when the field [`replayDeliveredEventsIndicator`] is `true`.

This is also available on the [Developer Dashboard webhooks page] and can be triggered by toggling the `Include delivered events` checkbox and providing a hirer.

[`replaywebhooksubscription` mutation]: /schema/mutation/replayWebhookSubscription
[`replaywebhooksubscription` filter input]: /schema/named-type/ReplayWebhookSubscription_FilterInput
[`replaydeliveredeventsindicator`]: /schema/named-type/ReplayWebhookSubscription_FilterInput#/field/replayDeliveredEventsIndicator
[Developer Dashboard webhooks page]: /manage/webhooks
